import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { chooseDevOrProd } from '../util/Environment';

// Firebase configuration for development and production environments
const firebaseConfig = chooseDevOrProd({
	development: {
		apiKey: 'AIzaSyDiVZkEfrCW4a4tjel0nnLd4h54GL-7u88',
		authDomain: 'mind-game-dev.firebaseapp.com',
		projectId: 'mind-game-dev',
		storageBucket: 'mind-game-dev.firebasestorage.app',
		messagingSenderId: '550967689098',
		appId: '1:550967689098:web:4985a25c92f410847b9273',
		measurementId: 'G-MTJCWH5ZW3'
	},
	production: {
		apiKey: 'AIzaSyBqKS-hJ-JzMapMCVVe-07YygCqdYyRrYI',
		authDomain: 'mind-game-prod.firebaseapp.com',
		projectId: 'mind-game-prod',
		storageBucket: 'mind-game-prod.firebasestorage.app',
		messagingSenderId: '317748636922',
		appId: '1:317748636922:web:c5cbbdf538145f1b86ed43',
		measurementId: 'G-VV3F61YFSF'
	}
});

/** Google Analytics property IDs */
export const gaPropertyId = chooseDevOrProd({
	development: '545961405',
	production: '546038873',
});

// Initialize Firebase
export const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
